import React from 'react';

import SelfSubmittingForm from '../../SelfSubmittingForm';
import Loader from '../../Loader';

export default function Redirect({ invoice: { method, url, data } }) {
  return (
    <>
      <Loader />
      <SelfSubmittingForm method={method} action={url} data={data} />
    </>
  );
}
